<template>
  <div class="flex flex-row ml-[30rem] mt-[3rem] gap-28">
    <img src="../assets/zara.png" />
    <img src="../assets/adidas.png" />
    <img src="../assets/gucci.png" />
  </div>
</template>

<script>
export default {
  name: `"Logo"`,
};
</script>
